// src/components/project/ProjectCard.js
import { Link } from 'react-router-dom';

/**
 * Карточка проекта — клик ведёт на страницу аналитики проекта
 * Данные проекта передаются через state, без API-запроса
 */
const ProjectCard = ({ project }) => {
  return (
      <Link
        to={`/analytics/project/${project.id}`}
        className="btn btn-primary w-100"
        state={{ project }} // Передаём весь объект project в AnalyticProjectPage
        aria-label={`Перейти к аналитике проекта "${project.name_text || project.name}"`}
      >
        <h6 className="mb-0">
          {project.name_text || project.name || 'Без названия'}
        </h6>
      </Link>
  );
};

export default ProjectCard;


